import classNames from 'classnames';
import React from 'react';
import { toTitleCase } from '../../../Lib/String';
import { IMessageProps, Message } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import './ListFieldSection.scss';

interface IListFieldSection {
  condensed?: boolean;
  heading?: string;
  messages?: IMessageProps[];
  single?: boolean;
  visible?: boolean;
  wide?: boolean;
  withAction?: boolean;
}

/**
 * A section designed for Field components that will flow them out horizontally based on screen width.
 */
const ListFieldSectionBase: React.FC<React.PropsWithChildren<IListFieldSection>> = ({
  children,
  condensed = false,
  heading,
  messages,
  single = false,
  visible = true,
  wide = false,
  withAction = false,
}) => {
  if (heading) {
    heading = toTitleCase(heading);
  }

  return !visible ? null : (
    <section
      className={classNames(
        'FieldListSection',
        { 'FieldListSection-wide': wide },
        { 'FieldListSection-single': single },
        //{ 'FieldListSection-condensed': condensed },
        { 'FieldListSection-withRightButton': withAction }
      )}
    >
      {heading && <h2 className="FieldListSection-Heading">{heading}</h2>}

      {children && <div className="FieldListSection-Content">{children}</div>}

      {messages && messages.length > 0 && (
        <div className="FieldListSection-Messages">
          {messages.map((props, i) => (
            <Message key={i} {...props} />
          ))}
        </div>
      )}
    </section>
  );
};

const ListFieldSection = withInjectedProps(ListFieldSectionBase);

export { ListFieldSection };
export default ListFieldSection;
